import React from 'react';
import { Link } from 'react-router-dom';

const AiDGTermsOfService: React.FC = () => {
  return (
    <section className="section">
      <div className="container">
        <div style={{ marginBottom: '2rem' }}>
          <Link 
            to="/" 
            style={{ 
              color: 'var(--accent-color)', 
              textDecoration: 'none',
              fontSize: '1rem',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            ← Back to Home
          </Link>
        </div>
        
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{ 
            fontSize: '2.5rem', 
            fontWeight: '700',
            marginBottom: '1rem',
            background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            AiDG Terms of Service
          </h1>
          <div className="section-divider"></div>
        </div>

        <div style={{ 
          maxWidth: '800px', 
          margin: '0 auto',
          lineHeight: '1.6',
          fontSize: '1rem'
        }}>
          <p style={{ marginBottom: '2rem', fontSize: '1rem' }}>
            <strong>Last Updated:</strong> March 15, 2026<br/>
            <strong>Contact:</strong> rapidnova2025@gmail.com
          </p>

          <p style={{ marginBottom: '2rem' }}>
            By downloading, installing, or using Aidance Generator ("the app", "we", "our"), you agree to these terms. If you don't agree, don't use the app.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>1. The Service</h2>
          <p style={{ marginBottom: '2rem' }}>
            AiDG lets you create dance videos by combining a reference photo with a reference dance (photo or video). The app may require a subscription for generation; limits and features can change. We provide the service "as is" and don't guarantee specific results, uptime, or that the app will meet your particular needs.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>2. Eligibility</h2>
          <p style={{ marginBottom: '2rem' }}>
            You must be at least 13 years old (or the age of consent in your country, if higher) to use the app. By using it, you confirm you meet this requirement and have the right to agree to these terms.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>3. Your Use of the App</h2>
          <p style={{ marginBottom: '0.5rem' }}><strong>Your responsibility</strong> — You are responsible for how you use the app and for any content you upload or create. You must have the right to use any photo or video you submit (e.g. you own it or have permission).</p>
          <p style={{ marginBottom: '0.5rem' }}><strong>Acceptable use</strong> — You may not:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Use the app for anything illegal or that infringes others' rights.</li>
            <li>Create or share content that impersonates someone without their clear consent, or that is defamatory, harassing, or harmful.</li>
            <li>Use the app to generate content for commercial resale of the service itself (e.g. bulk "generation as a service") unless we agree in writing.</li>
            <li>Circumvent usage limits, security (e.g. App Check), or subscription checks.</li>
            <li>Reverse-engineer, scrape, or abuse our systems.</li>
          </ul>
          <p style={{ marginBottom: '2rem' }}><strong>Consequences</strong> — If we reasonably believe you've broken these rules, we can suspend or end your access without refund. We may also report illegal activity.</p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>4. Content You Submit</h2>
          <p style={{ marginBottom: '2rem' }}>
            You keep ownership of the photos and videos you upload. By submitting them, you give us a limited license to use, process, and store that content only to provide and improve the service (e.g. generating your video, fixing issues). We don't claim ownership of your content or use it for unrelated marketing. You're responsible for ensuring you have the rights to everything you upload; we're not liable for your choice of content.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>5. Subscriptions and Payments</h2>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li><strong>Purchases</strong> — Subscriptions and in-app purchases are handled by Apple. You agree to Apple's payment terms. We don't see or store your payment card details.</li>
            <li><strong>Refunds</strong> — Refund requests are handled by Apple according to their policy. We don't control refund decisions.</li>
            <li><strong>Changes</strong> — We may change subscription plans, prices, or features (e.g. daily limits). We'll give notice where required (e.g. in the app or by email). Continued use after changes can mean you accept the new terms.</li>
            <li><strong>Cancellation</strong> — You cancel through your Apple subscription settings. No refund for the current period unless Apple approves it.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>6. Disclaimers</h2>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li><strong>"As is"</strong> — The app and service are provided "as is" and "as available." We disclaim all warranties, express or implied (including merchantability, fitness for a particular purpose, and non-infringement).</li>
            <li><strong>No guarantee of results</strong> — AI-generated output may vary. We don't guarantee accuracy, quality, or that generated videos will be suitable for any specific use.</li>
            <li><strong>Third parties</strong> — We rely on third-party services (e.g. cloud, AI, Apple, payment processors). We're not responsible for their failures, policies, or conduct.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>7. Limitation of Liability</h2>
          <p style={{ marginBottom: '0.5rem' }}>To the fullest extent permitted by law:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>We (and our affiliates, partners, and suppliers) are not liable for any indirect, incidental, special, consequential, or punitive damages (e.g. lost profits, data loss, reputational harm) arising from your use of the app or these terms.</li>
            <li>Our total liability for any claims related to the app or these terms is limited to the amount you paid us in the 12 months before the claim (or $100 if you paid nothing).</li>
          </ul>
          <p style={{ marginBottom: '2rem' }}>Some jurisdictions don't allow certain disclaimers or limits; in those places, our liability is limited only as much as the law allows.</p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>8. Indemnification</h2>
          <p style={{ marginBottom: '2rem' }}>
            You agree to indemnify and hold harmless the app, its operators, and its service providers from any claims, damages, losses, or costs (including reasonable legal fees) arising from: (a) your use of the app, (b) your content, or (c) your violation of these terms or any law.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>9. Ending Access</h2>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li><strong>By you</strong> — Stop using the app and cancel any subscription in Apple's settings.</li>
            <li><strong>By us</strong> — We may suspend or terminate your access at any time, with or without notice, if we believe you've violated these terms or for operational or legal reasons. Where the law requires, we'll give notice or a chance to fix the issue when reasonable.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>10. Changes to These Terms</h2>
          <p style={{ marginBottom: '2rem' }}>
            We may update these terms from time to time. We'll post the new version (e.g. in the app or at a link we provide) and update the "Last updated" date. If we make a material change, we may notify you in the app or by email where required. Your continued use after the change means you accept the updated terms. If you don't agree, stop using the app and cancel any subscription.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>11. General</h2>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li><strong>Entire agreement</strong> — These terms (together with our Privacy Policy and any in-app rules we publish) are the full agreement between you and us about the app.</li>
            <li><strong>Severability</strong> — If any part of these terms is found unenforceable, the rest remains in effect.</li>
            <li><strong>No waiver</strong> — Our failure to enforce a term doesn't waive our right to enforce it later.</li>
            <li><strong>Governing law</strong> — These terms are governed by the laws of Singapore, without regard to conflict-of-law rules. Any dispute will be resolved in the courts of Singapore, except where prohibited.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>12. Contact</h2>
          <p style={{ marginBottom: '1rem' }}>Questions about these terms?</p>
          <p style={{ marginBottom: '2rem' }}><strong>Email:</strong> rapidnova2025@gmail.com</p>

          <hr style={{ margin: '3rem 0', border: 'none', borderTop: '1px solid #eee' }} />
          <p style={{ marginBottom: '0', fontSize: '0.9rem', color: '#666', fontStyle: 'italic' }}>
            These are the Terms of Service for the Aidance Generator (AiDG) iOS application.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AiDGTermsOfService;
